import { Offcanvas, Stack, Button } from "react-bootstrap"
import { useShoppingCart } from "../context/ShoppingCartContext"
import { formatCurrency } from "../utilities/formatCurrency"
import { CartItemComponent } from "./CartItem"
import CheckoutButton from "../views/payment/CheckoutButton"
import { FaShoppingBag, FaShoppingCart } from "react-icons/fa"
import { useNavigate } from "react-router-dom"

type ShoppingCartProps = {
  isOpen: boolean
}

export function ShoppingCart({ isOpen }: ShoppingCartProps) {
  const { closeCart, cartItems } = useShoppingCart()
  const navigate = useNavigate()

  const total = cartItems.reduce((total, cartItem) => {
    return total + (cartItem.price || 0) * cartItem.quantity
  }, 0)

  const handleContinueShopping = () => {
    closeCart()
    navigate('/products')
  }
  return (
    <Offcanvas show={isOpen} onHide={closeCart} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title><FaShoppingCart size={30} /> Shopping Cart</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Stack gap={3}>
          {cartItems.map(item => (
            <CartItemComponent key={item.productId} {...item} />
          ))}
          <div className="ms-auto fw-bold fs-5">
            Total{" "}
            {formatCurrency(total)}
          </div>
          <div className="text-muted small text-end">
            * Taxes and Shipping will be calculated during checkout
          </div>
          <CheckoutButton cartItems={cartItems} />
          <Button
            variant="outline-secondary"
            onClick={handleContinueShopping}
            className="w-100"
          >
            Continue Shopping
          </Button>
        </Stack>
      </Offcanvas.Body>
    </Offcanvas>
  )
}